import { css } from "@emotion/css";

export const styles = {
  content: css({
    padding: "30px 60px 30px 60px",
  }),
  header: css({
    alignContent: "center",
    height: 64,
  }),
  layout: css({
    minHeight: "100vh",
  }),
};
